export default __webpack_public_path__ + "static/media/21 Track 21.a98df1aa.mp3";